// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"129":"7c7769f7","189":"5fa59ad3","220":"64988eb3","373":"7c7769f7","978":"5090a0af"}[chunkId] + ".chunk.css";
};